import { PageView } from "components/materials/page/PageView";
import { useParams } from "utils/routing";

export default function Page() {
  const pathParams = useParams();
  const pageId = pathParams.pageId;

  return <PageView pageId={pageId} />;
}
